// Phase 2 methods, identifiers 30 to 44 plus the read-side 127 to 129.
//
// Media bytes never travel in these messages. Uploads and downloads are
// separate HTTPS requests against object storage with short-lived scoped
// grants, so a large transfer cannot occupy the messaging connection and text
// stays responsive while a file is moving.

// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file chat/v1/methods_p2.proto (package chat.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Commit, Content, Draft, Entity, Message as Message$1, PageInfo } from "./common_pb";
import { file_chat_v1_common } from "./common_pb";
import type { ReactionState } from "./events_pb";
import { file_chat_v1_events } from "./events_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v1/methods_p2.proto.
 */
export const file_chat_v1_methods_p2: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v1_common, file_chat_v1_events]);

/**
 * @generated from message chat.v1.UploadedPart
 */
export type UploadedPart = Message<"chat.v1.UploadedPart"> & {
  /**
   * @generated from field: uint32 part_number = 1;
   */
  partNumber: number;

  /**
   * @generated from field: int64 size_bytes = 2;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string checksum = 3;
   */
  checksum: string;

  /**
   * @generated from field: string etag = 4;
   */
  etag: string;
};

/**
 * Describes the message chat.v1.UploadedPart.
 * Use `create(UploadedPartSchema)` to create a new message.
 */
export const UploadedPartSchema: GenMessage<UploadedPart> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 0);

/**
 * UploadInfo is the authoritative view of an upload's progress.
 *
 * The part list is what a client reconciles against after a reconnect. Local
 * progress is not authoritative: bytes written to a socket are not bytes the
 * object store accepted.
 *
 * @generated from message chat.v1.UploadInfo
 */
export type UploadInfo = Message<"chat.v1.UploadInfo"> & {
  /**
   * @generated from field: bytes upload_id = 1;
   */
  uploadId: Uint8Array;

  /**
   * @generated from field: bytes media_id = 2;
   */
  mediaId: Uint8Array;

  /**
   * @generated from field: string state = 3;
   */
  state: string;

  /**
   * @generated from field: uint32 part_size = 4;
   */
  partSize: number;

  /**
   * @generated from field: int64 expires_at = 5;
   */
  expiresAt: bigint;

  /**
   * @generated from field: repeated chat.v1.UploadedPart parts = 6;
   */
  parts: UploadedPart[];
};

/**
 * Describes the message chat.v1.UploadInfo.
 * Use `create(UploadInfoSchema)` to create a new message.
 */
export const UploadInfoSchema: GenMessage<UploadInfo> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 1);

/**
 * @generated from message chat.v1.MediaVariant
 */
export type MediaVariant = Message<"chat.v1.MediaVariant"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string mime = 2;
   */
  mime: string;

  /**
   * @generated from field: int64 size_bytes = 3;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional uint32 width = 4;
   */
  width?: number | undefined;

  /**
   * @generated from field: optional uint32 height = 5;
   */
  height?: number | undefined;

  /**
   * @generated from field: optional uint32 duration_ms = 6;
   */
  durationMs?: number | undefined;

  /**
   * 100 normalized samples for a voice note, produced by the media worker so
   * every client draws the same waveform rather than each computing its own.
   *
   * @generated from field: repeated uint32 waveform = 7;
   */
  waveform: number[];
};

/**
 * Describes the message chat.v1.MediaVariant.
 * Use `create(MediaVariantSchema)` to create a new message.
 */
export const MediaVariantSchema: GenMessage<MediaVariant> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 2);

/**
 * @generated from message chat.v1.MediaInfo
 */
export type MediaInfo = Message<"chat.v1.MediaInfo"> & {
  /**
   * @generated from field: bytes media_id = 1;
   */
  mediaId: Uint8Array;

  /**
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: int64 size_bytes = 3;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string mime = 4;
   */
  mime: string;

  /**
   * @generated from field: repeated chat.v1.MediaVariant variants = 5;
   */
  variants: MediaVariant[];

  /**
   * @generated from field: optional string failure_code = 6;
   */
  failureCode?: string | undefined;
};

/**
 * Describes the message chat.v1.MediaInfo.
 * Use `create(MediaInfoSchema)` to create a new message.
 */
export const MediaInfoSchema: GenMessage<MediaInfo> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 3);

/**
 * @generated from message chat.v1.Header
 */
export type Header = Message<"chat.v1.Header"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message chat.v1.Header.
 * Use `create(HeaderSchema)` to create a new message.
 */
export const HeaderSchema: GenMessage<Header> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 4);

/**
 * @generated from message chat.v1.CreateUploadRequest
 */
export type CreateUploadRequest = Message<"chat.v1.CreateUploadRequest"> & {
  /**
   * @generated from field: int64 size_bytes = 1;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: bytes sha256 = 2;
   */
  sha256: Uint8Array;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;

  /**
   * A hint only. The real type is detected from the bytes; a declared type
   * never authorizes inline rendering.
   *
   * @generated from field: string mime_hint = 4;
   */
  mimeHint: string;

  /**
   * @generated from field: string media_kind = 5;
   */
  mediaKind: string;

  /**
   * @generated from field: bytes client_op_id = 6;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CreateUploadRequest.
 * Use `create(CreateUploadRequestSchema)` to create a new message.
 */
export const CreateUploadRequestSchema: GenMessage<CreateUploadRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 5);

/**
 * @generated from message chat.v1.CreateUploadResponse
 */
export type CreateUploadResponse = Message<"chat.v1.CreateUploadResponse"> & {
  /**
   * @generated from field: chat.v1.UploadInfo upload = 1;
   */
  upload?: UploadInfo | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CreateUploadResponse.
 * Use `create(CreateUploadResponseSchema)` to create a new message.
 */
export const CreateUploadResponseSchema: GenMessage<CreateUploadResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 6);

/**
 * @generated from message chat.v1.GetUploadPartsRequest
 */
export type GetUploadPartsRequest = Message<"chat.v1.GetUploadPartsRequest"> & {
  /**
   * @generated from field: bytes upload_id = 1;
   */
  uploadId: Uint8Array;
};

/**
 * Describes the message chat.v1.GetUploadPartsRequest.
 * Use `create(GetUploadPartsRequestSchema)` to create a new message.
 */
export const GetUploadPartsRequestSchema: GenMessage<GetUploadPartsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 7);

/**
 * @generated from message chat.v1.GetUploadPartsResponse
 */
export type GetUploadPartsResponse = Message<"chat.v1.GetUploadPartsResponse"> & {
  /**
   * @generated from field: chat.v1.UploadInfo upload = 1;
   */
  upload?: UploadInfo | undefined;
};

/**
 * Describes the message chat.v1.GetUploadPartsResponse.
 * Use `create(GetUploadPartsResponseSchema)` to create a new message.
 */
export const GetUploadPartsResponseSchema: GenMessage<GetUploadPartsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 8);

/**
 * @generated from message chat.v1.GetUploadPartGrantRequest
 */
export type GetUploadPartGrantRequest = Message<"chat.v1.GetUploadPartGrantRequest"> & {
  /**
   * @generated from field: bytes upload_id = 1;
   */
  uploadId: Uint8Array;

  /**
   * @generated from field: uint32 part_number = 2;
   */
  partNumber: number;
};

/**
 * Describes the message chat.v1.GetUploadPartGrantRequest.
 * Use `create(GetUploadPartGrantRequestSchema)` to create a new message.
 */
export const GetUploadPartGrantRequestSchema: GenMessage<GetUploadPartGrantRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 9);

/**
 * @generated from message chat.v1.GetUploadPartGrantResponse
 */
export type GetUploadPartGrantResponse = Message<"chat.v1.GetUploadPartGrantResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;

  /**
   * @generated from field: repeated chat.v1.Header required_headers = 3;
   */
  requiredHeaders: Header[];
};

/**
 * Describes the message chat.v1.GetUploadPartGrantResponse.
 * Use `create(GetUploadPartGrantResponseSchema)` to create a new message.
 */
export const GetUploadPartGrantResponseSchema: GenMessage<GetUploadPartGrantResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 10);

/**
 * @generated from message chat.v1.CompleteUploadRequest
 */
export type CompleteUploadRequest = Message<"chat.v1.CompleteUploadRequest"> & {
  /**
   * @generated from field: bytes upload_id = 1;
   */
  uploadId: Uint8Array;

  /**
   * @generated from field: repeated chat.v1.UploadedPart parts = 2;
   */
  parts: UploadedPart[];

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CompleteUploadRequest.
 * Use `create(CompleteUploadRequestSchema)` to create a new message.
 */
export const CompleteUploadRequestSchema: GenMessage<CompleteUploadRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 11);

/**
 * @generated from message chat.v1.CompleteUploadResponse
 */
export type CompleteUploadResponse = Message<"chat.v1.CompleteUploadResponse"> & {
  /**
   * @generated from field: chat.v1.UploadInfo upload = 1;
   */
  upload?: UploadInfo | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CompleteUploadResponse.
 * Use `create(CompleteUploadResponseSchema)` to create a new message.
 */
export const CompleteUploadResponseSchema: GenMessage<CompleteUploadResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 12);

/**
 * @generated from message chat.v1.CancelUploadRequest
 */
export type CancelUploadRequest = Message<"chat.v1.CancelUploadRequest"> & {
  /**
   * @generated from field: bytes upload_id = 1;
   */
  uploadId: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 2;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CancelUploadRequest.
 * Use `create(CancelUploadRequestSchema)` to create a new message.
 */
export const CancelUploadRequestSchema: GenMessage<CancelUploadRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 13);

/**
 * @generated from message chat.v1.CancelUploadResponse
 */
export type CancelUploadResponse = Message<"chat.v1.CancelUploadResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CancelUploadResponse.
 * Use `create(CancelUploadResponseSchema)` to create a new message.
 */
export const CancelUploadResponseSchema: GenMessage<CancelUploadResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 14);

/**
 * @generated from message chat.v1.GetMediaStatusRequest
 */
export type GetMediaStatusRequest = Message<"chat.v1.GetMediaStatusRequest"> & {
  /**
   * @generated from field: bytes media_id = 1;
   */
  mediaId: Uint8Array;
};

/**
 * Describes the message chat.v1.GetMediaStatusRequest.
 * Use `create(GetMediaStatusRequestSchema)` to create a new message.
 */
export const GetMediaStatusRequestSchema: GenMessage<GetMediaStatusRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 15);

/**
 * @generated from message chat.v1.GetMediaStatusResponse
 */
export type GetMediaStatusResponse = Message<"chat.v1.GetMediaStatusResponse"> & {
  /**
   * @generated from field: chat.v1.MediaInfo media = 1;
   */
  media?: MediaInfo | undefined;

  /**
   * A scoped capability for attaching this object, present only when it is
   * READY. Without it no attachment can be sent at all: the send path requires
   * one and nothing else returns it.
   *
   * @generated from field: optional bytes capability = 2;
   */
  capability?: Uint8Array | undefined;
};

/**
 * Describes the message chat.v1.GetMediaStatusResponse.
 * Use `create(GetMediaStatusResponseSchema)` to create a new message.
 */
export const GetMediaStatusResponseSchema: GenMessage<GetMediaStatusResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 16);

/**
 * @generated from message chat.v1.GetDownloadGrantRequest
 */
export type GetDownloadGrantRequest = Message<"chat.v1.GetDownloadGrantRequest"> & {
  /**
   * @generated from field: optional bytes conversation_id = 1;
   */
  conversationId?: Uint8Array | undefined;

  /**
   * @generated from field: optional bytes message_id = 2;
   */
  messageId?: Uint8Array | undefined;

  /**
   * @generated from field: optional bytes story_id = 3;
   */
  storyId?: Uint8Array | undefined;

  /**
   * @generated from field: bytes media_id = 4;
   */
  mediaId: Uint8Array;

  /**
   * @generated from field: string variant = 5;
   */
  variant: string;

  /**
   * SENDER_AVATAR requires conversation_id, message_id, media_id and variant,
   * and forbids story_id: the grant is authorized through the message whose
   * displayed sender owns the avatar, so there has to be a message to authorize
   * it through.
   *
   * @generated from field: chat.v1.MediaGrantPurpose purpose = 6;
   */
  purpose: MediaGrantPurpose;
};

/**
 * Describes the message chat.v1.GetDownloadGrantRequest.
 * Use `create(GetDownloadGrantRequestSchema)` to create a new message.
 */
export const GetDownloadGrantRequestSchema: GenMessage<GetDownloadGrantRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 17);

/**
 * @generated from message chat.v1.GetDownloadGrantResponse
 */
export type GetDownloadGrantResponse = Message<"chat.v1.GetDownloadGrantResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;

  /**
   * @generated from field: string etag = 3;
   */
  etag: string;
};

/**
 * Describes the message chat.v1.GetDownloadGrantResponse.
 * Use `create(GetDownloadGrantResponseSchema)` to create a new message.
 */
export const GetDownloadGrantResponseSchema: GenMessage<GetDownloadGrantResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 18);

/**
 * @generated from message chat.v1.SetReactionRequest
 */
export type SetReactionRequest = Message<"chat.v1.SetReactionRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: string reaction = 3;
   */
  reaction: string;

  /**
   * @generated from field: bool active = 4;
   */
  active: boolean;

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetReactionRequest.
 * Use `create(SetReactionRequestSchema)` to create a new message.
 */
export const SetReactionRequestSchema: GenMessage<SetReactionRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 19);

/**
 * @generated from message chat.v1.SetReactionResponse
 */
export type SetReactionResponse = Message<"chat.v1.SetReactionResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetReactionResponse.
 * Use `create(SetReactionResponseSchema)` to create a new message.
 */
export const SetReactionResponseSchema: GenMessage<SetReactionResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 20);

/**
 * @generated from message chat.v1.SetDraftRequest
 */
export type SetDraftRequest = Message<"chat.v1.SetDraftRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: int64 expected_version = 2;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: chat.v1.Content content = 3;
   */
  content?: Content | undefined;

  /**
   * Uploads that have not reached READY. A draft may reference them; sending
   * may not, and they create no durable media reference.
   *
   * @generated from field: repeated bytes pending_upload_ids = 4;
   */
  pendingUploadIds: Uint8Array[];

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetDraftRequest.
 * Use `create(SetDraftRequestSchema)` to create a new message.
 */
export const SetDraftRequestSchema: GenMessage<SetDraftRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 21);

/**
 * @generated from message chat.v1.SetDraftResponse
 */
export type SetDraftResponse = Message<"chat.v1.SetDraftResponse"> & {
  /**
   * @generated from field: chat.v1.Draft draft = 1;
   */
  draft?: Draft | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetDraftResponse.
 * Use `create(SetDraftResponseSchema)` to create a new message.
 */
export const SetDraftResponseSchema: GenMessage<SetDraftResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 22);

/**
 * @generated from message chat.v1.SetPinRequest
 */
export type SetPinRequest = Message<"chat.v1.SetPinRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: bool pinned = 3;
   */
  pinned: boolean;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetPinRequest.
 * Use `create(SetPinRequestSchema)` to create a new message.
 */
export const SetPinRequestSchema: GenMessage<SetPinRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 23);

/**
 * @generated from message chat.v1.SetPinResponse
 */
export type SetPinResponse = Message<"chat.v1.SetPinResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetPinResponse.
 * Use `create(SetPinResponseSchema)` to create a new message.
 */
export const SetPinResponseSchema: GenMessage<SetPinResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 24);

/**
 * ForwardMessage creates a new message through ordinary send semantics.
 *
 * Origin attribution is carried only when the source permits it. A
 * protected-content conversation rejects forwarding outright, while
 * acknowledging that a recipient can still photograph their screen: the
 * restriction is a policy signal, not a technical guarantee.
 *
 * @generated from message chat.v1.ForwardMessageRequest
 */
export type ForwardMessageRequest = Message<"chat.v1.ForwardMessageRequest"> & {
  /**
   * @generated from field: bytes source_conversation_id = 1;
   */
  sourceConversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: bytes destination_conversation_id = 3;
   */
  destinationConversationId: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.ForwardMessageRequest.
 * Use `create(ForwardMessageRequestSchema)` to create a new message.
 */
export const ForwardMessageRequestSchema: GenMessage<ForwardMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 25);

/**
 * @generated from message chat.v1.ForwardMessageResponse
 */
export type ForwardMessageResponse = Message<"chat.v1.ForwardMessageResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.ForwardMessageResponse.
 * Use `create(ForwardMessageResponseSchema)` to create a new message.
 */
export const ForwardMessageResponseSchema: GenMessage<ForwardMessageResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 26);

/**
 * @generated from message chat.v1.ScheduleMessageRequest
 */
export type ScheduleMessageRequest = Message<"chat.v1.ScheduleMessageRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: chat.v1.Content content = 2;
   */
  content?: Content | undefined;

  /**
   * @generated from field: int64 due_at = 3;
   */
  dueAt: bigint;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.ScheduleMessageRequest.
 * Use `create(ScheduleMessageRequestSchema)` to create a new message.
 */
export const ScheduleMessageRequestSchema: GenMessage<ScheduleMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 27);

/**
 * @generated from message chat.v1.ScheduleMessageResponse
 */
export type ScheduleMessageResponse = Message<"chat.v1.ScheduleMessageResponse"> & {
  /**
   * @generated from field: bytes schedule_id = 1;
   */
  scheduleId: Uint8Array;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.ScheduleMessageResponse.
 * Use `create(ScheduleMessageResponseSchema)` to create a new message.
 */
export const ScheduleMessageResponseSchema: GenMessage<ScheduleMessageResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 28);

/**
 * @generated from message chat.v1.CancelScheduleRequest
 */
export type CancelScheduleRequest = Message<"chat.v1.CancelScheduleRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes schedule_id = 2;
   */
  scheduleId: Uint8Array;

  /**
   * @generated from field: int64 expected_version = 3;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CancelScheduleRequest.
 * Use `create(CancelScheduleRequestSchema)` to create a new message.
 */
export const CancelScheduleRequestSchema: GenMessage<CancelScheduleRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 29);

/**
 * @generated from message chat.v1.CancelScheduleResponse
 */
export type CancelScheduleResponse = Message<"chat.v1.CancelScheduleResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CancelScheduleResponse.
 * Use `create(CancelScheduleResponseSchema)` to create a new message.
 */
export const CancelScheduleResponseSchema: GenMessage<CancelScheduleResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 30);

/**
 * @generated from message chat.v1.SearchHit
 */
export type SearchHit = Message<"chat.v1.SearchHit"> & {
  /**
   * @generated from field: chat.v1.Message message = 1;
   */
  message?: Message$1 | undefined;

  /**
   * @generated from field: repeated chat.v1.Entity highlighted_ranges = 2;
   */
  highlightedRanges: Entity[];

  /**
   * @generated from field: string conversation_title = 3;
   */
  conversationTitle: string;
};

/**
 * Describes the message chat.v1.SearchHit.
 * Use `create(SearchHitSchema)` to create a new message.
 */
export const SearchHitSchema: GenMessage<SearchHit> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 31);

/**
 * SearchHistory searches only conversations the caller explicitly names and is
 * currently authorized to read. There is no cross-account search and no
 * arbitrary regular expression.
 *
 * @generated from message chat.v1.SearchHistoryRequest
 */
export type SearchHistoryRequest = Message<"chat.v1.SearchHistoryRequest"> & {
  /**
   * @generated from field: repeated bytes conversation_ids = 1;
   */
  conversationIds: Uint8Array[];

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @generated from field: optional bytes sender_id = 3;
   */
  senderId?: Uint8Array | undefined;

  /**
   * @generated from field: optional string media_kind = 4;
   */
  mediaKind?: string | undefined;

  /**
   * @generated from field: optional int64 from = 5;
   */
  from?: bigint | undefined;

  /**
   * @generated from field: optional int64 to = 6;
   */
  to?: bigint | undefined;

  /**
   * @generated from field: optional bytes cursor = 7;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 8;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.SearchHistoryRequest.
 * Use `create(SearchHistoryRequestSchema)` to create a new message.
 */
export const SearchHistoryRequestSchema: GenMessage<SearchHistoryRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 32);

/**
 * @generated from message chat.v1.SearchHistoryResponse
 */
export type SearchHistoryResponse = Message<"chat.v1.SearchHistoryResponse"> & {
  /**
   * @generated from field: repeated chat.v1.SearchHit hits = 1;
   */
  hits: SearchHit[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.SearchHistoryResponse.
 * Use `create(SearchHistoryResponseSchema)` to create a new message.
 */
export const SearchHistoryResponseSchema: GenMessage<SearchHistoryResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 33);

/**
 * @generated from message chat.v1.SetPlaybackPositionRequest
 */
export type SetPlaybackPositionRequest = Message<"chat.v1.SetPlaybackPositionRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: uint32 position_ms = 3;
   */
  positionMs: number;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetPlaybackPositionRequest.
 * Use `create(SetPlaybackPositionRequestSchema)` to create a new message.
 */
export const SetPlaybackPositionRequestSchema: GenMessage<SetPlaybackPositionRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 34);

/**
 * @generated from message chat.v1.SetPlaybackPositionResponse
 */
export type SetPlaybackPositionResponse = Message<"chat.v1.SetPlaybackPositionResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetPlaybackPositionResponse.
 * Use `create(SetPlaybackPositionResponseSchema)` to create a new message.
 */
export const SetPlaybackPositionResponseSchema: GenMessage<SetPlaybackPositionResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 35);

/**
 * @generated from message chat.v1.GetMessageRequest
 */
export type GetMessageRequest = Message<"chat.v1.GetMessageRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;
};

/**
 * Describes the message chat.v1.GetMessageRequest.
 * Use `create(GetMessageRequestSchema)` to create a new message.
 */
export const GetMessageRequestSchema: GenMessage<GetMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 36);

/**
 * @generated from message chat.v1.GetMessageResponse
 */
export type GetMessageResponse = Message<"chat.v1.GetMessageResponse"> & {
  /**
   * @generated from field: chat.v1.Message message = 1;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message chat.v1.GetMessageResponse.
 * Use `create(GetMessageResponseSchema)` to create a new message.
 */
export const GetMessageResponseSchema: GenMessage<GetMessageResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 37);

/**
 * @generated from message chat.v1.ReactionCount
 */
export type ReactionCount = Message<"chat.v1.ReactionCount"> & {
  /**
   * @generated from field: string reaction = 1;
   */
  reaction: string;

  /**
   * @generated from field: uint32 count = 2;
   */
  count: number;
};

/**
 * Describes the message chat.v1.ReactionCount.
 * Use `create(ReactionCountSchema)` to create a new message.
 */
export const ReactionCountSchema: GenMessage<ReactionCount> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 38);

/**
 * @generated from message chat.v1.ListMessageReactionsRequest
 */
export type ListMessageReactionsRequest = Message<"chat.v1.ListMessageReactionsRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 3;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.ListMessageReactionsRequest.
 * Use `create(ListMessageReactionsRequestSchema)` to create a new message.
 */
export const ListMessageReactionsRequestSchema: GenMessage<ListMessageReactionsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 39);

/**
 * @generated from message chat.v1.ListMessageReactionsResponse
 */
export type ListMessageReactionsResponse = Message<"chat.v1.ListMessageReactionsResponse"> & {
  /**
   * @generated from field: repeated chat.v1.ReactionState reactions = 1;
   */
  reactions: ReactionState[];

  /**
   * @generated from field: repeated chat.v1.ReactionCount counts = 2;
   */
  counts: ReactionCount[];

  /**
   * @generated from field: chat.v1.PageInfo page = 3;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.ListMessageReactionsResponse.
 * Use `create(ListMessageReactionsResponseSchema)` to create a new message.
 */
export const ListMessageReactionsResponseSchema: GenMessage<ListMessageReactionsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 40);

/**
 * @generated from message chat.v1.ListPinsRequest
 */
export type ListPinsRequest = Message<"chat.v1.ListPinsRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.ListPinsRequest.
 * Use `create(ListPinsRequestSchema)` to create a new message.
 */
export const ListPinsRequestSchema: GenMessage<ListPinsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 41);

/**
 * @generated from message chat.v1.ListPinsResponse
 */
export type ListPinsResponse = Message<"chat.v1.ListPinsResponse"> & {
  /**
   * @generated from field: repeated chat.v1.Message messages = 1;
   */
  messages: Message$1[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.ListPinsResponse.
 * Use `create(ListPinsResponseSchema)` to create a new message.
 */
export const ListPinsResponseSchema: GenMessage<ListPinsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p2, 42);

/**
 * @generated from enum chat.v1.MethodIdP2
 */
export enum MethodIdP2 {
  /**
   * @generated from enum value: METHOD_ID_P2_UNKNOWN = 0;
   */
  METHOD_ID_P2_UNKNOWN = 0,

  /**
   * @generated from enum value: METHOD_ID_CREATE_UPLOAD = 30;
   */
  METHOD_ID_CREATE_UPLOAD = 30,

  /**
   * @generated from enum value: METHOD_ID_GET_UPLOAD_PARTS = 31;
   */
  METHOD_ID_GET_UPLOAD_PARTS = 31,

  /**
   * @generated from enum value: METHOD_ID_GET_UPLOAD_PART_GRANT = 32;
   */
  METHOD_ID_GET_UPLOAD_PART_GRANT = 32,

  /**
   * @generated from enum value: METHOD_ID_COMPLETE_UPLOAD = 33;
   */
  METHOD_ID_COMPLETE_UPLOAD = 33,

  /**
   * @generated from enum value: METHOD_ID_CANCEL_UPLOAD = 34;
   */
  METHOD_ID_CANCEL_UPLOAD = 34,

  /**
   * @generated from enum value: METHOD_ID_GET_MEDIA_STATUS = 35;
   */
  METHOD_ID_GET_MEDIA_STATUS = 35,

  /**
   * @generated from enum value: METHOD_ID_GET_DOWNLOAD_GRANT = 36;
   */
  METHOD_ID_GET_DOWNLOAD_GRANT = 36,

  /**
   * @generated from enum value: METHOD_ID_SET_REACTION = 37;
   */
  METHOD_ID_SET_REACTION = 37,

  /**
   * @generated from enum value: METHOD_ID_SET_DRAFT = 38;
   */
  METHOD_ID_SET_DRAFT = 38,

  /**
   * @generated from enum value: METHOD_ID_SET_PIN = 39;
   */
  METHOD_ID_SET_PIN = 39,

  /**
   * @generated from enum value: METHOD_ID_FORWARD_MESSAGE = 40;
   */
  METHOD_ID_FORWARD_MESSAGE = 40,

  /**
   * @generated from enum value: METHOD_ID_SCHEDULE_MESSAGE = 41;
   */
  METHOD_ID_SCHEDULE_MESSAGE = 41,

  /**
   * @generated from enum value: METHOD_ID_CANCEL_SCHEDULE = 42;
   */
  METHOD_ID_CANCEL_SCHEDULE = 42,

  /**
   * @generated from enum value: METHOD_ID_SEARCH_HISTORY = 43;
   */
  METHOD_ID_SEARCH_HISTORY = 43,

  /**
   * @generated from enum value: METHOD_ID_SET_PLAYBACK_POSITION = 44;
   */
  METHOD_ID_SET_PLAYBACK_POSITION = 44,

  /**
   * @generated from enum value: METHOD_ID_GET_MESSAGE = 127;
   */
  METHOD_ID_GET_MESSAGE = 127,

  /**
   * @generated from enum value: METHOD_ID_LIST_MESSAGE_REACTIONS = 128;
   */
  METHOD_ID_LIST_MESSAGE_REACTIONS = 128,

  /**
   * @generated from enum value: METHOD_ID_LIST_PINS = 129;
   */
  METHOD_ID_LIST_PINS = 129,
}

/**
 * Describes the enum chat.v1.MethodIdP2.
 */
export const MethodIdP2Schema: GenEnum<MethodIdP2> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p2, 0);

/**
 * MediaGrantPurpose says what the requested object is being fetched as.
 *
 * It exists because a sender's avatar is authorized differently from a message's
 * attachment. An attachment is authorized by the message that carries it; an
 * avatar belongs to the identity the message is displayed under, and that
 * identity may be a channel the caller cannot otherwise read. Without the
 * distinction the only ways to show an avatar are to authorize it as though it
 * were conversation content, or not to show it.
 *
 * @generated from enum chat.v1.MediaGrantPurpose
 */
export enum MediaGrantPurpose {
  /**
   * Preserves the existing attachment and story behaviour exactly, so a client
   * that does not set the field is unaffected.
   *
   * @generated from enum value: MEDIA_GRANT_PURPOSE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_GRANT_PURPOSE_CONTENT = 1;
   */
  CONTENT = 1,

  /**
   * @generated from enum value: MEDIA_GRANT_PURPOSE_SENDER_AVATAR = 2;
   */
  SENDER_AVATAR = 2,

  /**
   * A conversation photo. Authorized by the caller's access to the conversation
   * and against that conversation's current photo, so a member sees the group
   * picture without that becoming a grant for any object the group ever used.
   *
   * @generated from enum value: MEDIA_GRANT_PURPOSE_CONVERSATION_PHOTO = 3;
   */
  CONVERSATION_PHOTO = 3,
}

/**
 * Describes the enum chat.v1.MediaGrantPurpose.
 */
export const MediaGrantPurposeSchema: GenEnum<MediaGrantPurpose> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p2, 1);

